export default __webpack_public_path__ + "static/media/16_9 Image Placeholder.fe812f61.svg";